import OrgGroupsContainer from './OrgGroupsContainer';

export default OrgGroupsContainer;
